import { Form, Formik } from "formik";
import ConnectedAdressInput from "./ConnectedAddressInput";
import useCart from "hooks/useCart";
import { setEligibility } from "../localOfferEligibility/LocalOfferEligibility";
import { pushLocalOfferActivation } from "lib/gtm";
import { FC } from "react";

interface ConnectedAdressFormProps {
  autoFocusField: boolean;
  addCatalogsToRefinementList: () => void;
  disabled: boolean;
  id: string;
  children: JSX.Element;
  vertical?: boolean;
  toggleInputFocus?: () => void;
  size?: "small" | undefined;
}

export const ConnectedAdressForm: FC<ConnectedAdressFormProps> = ({
  autoFocusField,
  addCatalogsToRefinementList,
  disabled,
  children = null,
  vertical = false,
  id,
  toggleInputFocus = () => undefined,
  size = undefined,
}) => {
  const [cart, dispatch] = useCart();
  const submitForm = (values) => {
    if (values.zipcode) {
      setEligibility(values.zipcode, true).then(() => {
        dispatch({
          type: "updateShipping",
          shipping: {
            address: {
              ...values,
            },
          },
        });
        addCatalogsToRefinementList();
      });
      pushLocalOfferActivation(values.zipcode, id);
    }
  };
  return (
    <Formik
      initialValues={{
        street_number: cart?.shipping?.address.street_number || "",
        street: cart?.shipping?.address.street || "",
        city: cart?.shipping?.address.city || "",
        zipcode: cart?.shipping?.address.zipcode || "",
        full_address: cart?.shipping?.address.full_address || "",
        address_input_text: cart?.shipping?.address.full_address || "",
      }}
      onSubmit={(values, formik) => {
        formik.setSubmitting(false);
        submitForm(values);
      }}
    >
      <Form>
        <ConnectedAdressInput
          id={id}
          vertical={vertical}
          autoFocusField={autoFocusField}
          disabled={disabled}
          toggleInputFocus={toggleInputFocus}
          size={size}
        >
          {children}
        </ConnectedAdressInput>
      </Form>
    </Formik>
  );
};

export default ConnectedAdressForm;
